"use client";

import { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Stat = {
  value: string;
  numeric: number;
  prefix: string;
  suffix: string;
  decimals: number;
  label: string;
};
const stats: Stat[] = [{
  value: "15+",
  numeric: 15,
  prefix: "",
  suffix: "+",
  decimals: 0,
  label: "Anni di esperienza"
}, {
  value: "15+",
  numeric: 15,
  prefix: "",
  suffix: "+",
  decimals: 0,
  label: "Brand seguiti"
}, {
  value: "5",
  numeric: 5,
  prefix: "",
  suffix: "",
  decimals: 0,
  label: "Lingue parlate"
}, {
  value: "30+",
  numeric: 30,
  prefix: "",
  suffix: "+",
  decimals: 0,
  label: "Progetti completati"
}];
function CountUp({
  target,
  prefix,
  suffix,
  decimals,
  start
}: {
  target: number;
  prefix: string;
  suffix: string;
  decimals: number;
  start: boolean;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    const duration = 1800;
    const startTime = performance.now();
    let raf = 0;
    const tick = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(target * eased);
      if (progress < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        setCount(target);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, target]);
  const formatted = decimals > 0 ? count.toFixed(decimals) : Math.floor(count).toLocaleString("en-US");
  return <span className="tabular-nums">
      {prefix}
      {formatted}
      {suffix}
    </span>;
}
export default function Impact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.3
  });
  return <section data-section-id="3420" id="impact-by-the-numbers" className="relative bg-background text-foreground py-20 px-4 overflow-hidden">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="w-[800px] h-[800px] max-w-full opacity-20 blur-3xl" style={{
        background: "radial-gradient(circle, var(--primary) 0%, transparent 60%)"
      }} />
      </div>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "linear-gradient(var(--foreground) 1px, transparent 1px), linear-gradient(90deg, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "48px 48px"
    }} />

      <div ref={ref} className="relative max-w-7xl mx-auto">
        {}
        <div className="flex flex-col items-center text-center mb-16 md:mb-20">
          <div className="flex items-center justify-center gap-4 mb-6 w-full max-w-md">
            <span className="h-px flex-1" style={{
            backgroundColor: "var(--primary)"
          }} aria-hidden="true" />
            <span className="font-default text-xs uppercase tracking-[0.25em] text-muted-foreground">15 ANNI&nbsp;</span>
            <span className="h-px flex-1" style={{
            backgroundColor: "var(--primary)"
          }} aria-hidden="true" />
          </div>
          <h2 className="font-default font-bold text-4xl sm:text-5xl md:text-6xl lg:text-[64px] leading-tight tracking-tight text-foreground">
            statistics
          </h2>
        </div>

        {}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-12 md:gap-y-0">
          {stats.map((stat, i) => <div data-index={i} key={stat.label} className={`relative flex flex-col items-center justify-start text-center px-4 md:px-6 ${i > 0 ? "md:border-l md:border-border" : ""} ${i === 2 ? "border-l border-border md:border-l" : ""} ${i === 1 ? "border-l border-border md:border-l" : ""}`}>
              {}
              <span aria-hidden="true" className="absolute top-0 left-2 md:left-4 w-3 h-3 border-t border-l" style={{
            borderColor: "var(--primary)"
          }} />
              <span aria-hidden="true" className="absolute bottom-0 right-2 md:right-4 w-3 h-3 border-b border-r" style={{
            borderColor: "var(--primary)"
          }} />

              {}
              <div className="relative pt-4 pb-4">
                <div className="font-default font-bold text-6xl sm:text-7xl md:text-8xl lg:text-[110px] leading-none text-yellow-400">
                  <CountUp target={stat.numeric} prefix={stat.prefix} suffix={stat.suffix} decimals={stat.decimals} start={isVisible} />
                </div>
              </div>

              {}
              <span aria-hidden="true" className="block h-px w-10 my-4" style={{
            backgroundColor: "var(--primary)"
          }} />

              {}
              <span className="font-default text-[11px] sm:text-xs uppercase tracking-[0.2em] text-muted-foreground">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}